import { H1 } from '../../../../styles/styles';
import { css } from '@emotion/core';

export const header = css(
    H1,
    {
        marginBottom: '25px',
    }
);
